import React from 'react';
import { Overlays } from '../overlays';
import InputField from '../inputField';

const TeamNameOverlay = ({
  handleTeamNameChange,
  setShowTeamNamePopup,
  showTeamNamePopup,
  handlesaveteam
}) => {
  return (
    <Overlays
      overlayName={'createTeam'}
      overlayConfig={{
        noOverlayHead: true,
        overlayCloseConfig: true,
        noOverlayClose: false,
        noOverlayFoot: true,
        noOverlayReset: false,
        submitBtn: true,
        cancelBtn: true,
        onCancelClick: () => {
          setShowTeamNamePopup({
            ...showTeamNamePopup,
            flag: !showTeamNamePopup.flag
          });
        },
        isDisabled: showTeamNamePopup?.errMsg ? true : false,
        title: 'GIVE A NAME',
        titleTransKey: 'overlay_title_give_your_team_name',
        btnPrimary: 'Save',
        btnPrimaryTransKey: 'cta_save',
        btnSecondary: 'Cancel',
        btnSecondaryTransKey: 'cta_cancel',
        onConfirmClick: () => {
          handlesaveteam();
        }
      }}
    >
      <div className='si-createTeam__wrap'>
        <div className='si-createTeam__form'>
          <InputField
            inputID={'createTeamName'}
            inputValidate={false}
            placeholderLabel={'Enter Your Team Name'}
            validationConfig={{ errMsg: showTeamNamePopup?.errMsg }}
            inputCharLimit={25}
            maxLength={25}
            ismaxlength={true}
            handleInput={(e) => handleTeamNameChange(e)}
            labelConfig={{
              inputLbl: 'Team Name',
              inputID: 'createTeamName',
              transInputLbl: 'overlay_create__team_input_label'
            }}
            extraAttri={{
              id: 'createTeamName',
              placeholder: 'Team Name'
            }}
            inputText={showTeamNamePopup?.teamName}
          />
        </div>
      </div>
    </Overlays>
  );
};

export default TeamNameOverlay;
